module.exports = __webpack_public_path__ + "static/media/blog-6.2f1a308d.png";